document.addEventListener('DOMContentLoaded', function() {
    console.log("[Accordion] DOM fully loaded and parsed");
  
    var acc = document.getElementsByClassName("accordion");
    console.log("[Accordion] Found", acc.length, "accordion elements:", acc);
  
    var i;
    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function() {
        console.log("[Accordion] Click event triggered on:", this);
  
        if (this.classList.contains('active')) {
          console.log("[Accordion] Removing 'active' class");
          this.classList.remove('active');
        } else {
          console.log("[Accordion] Adding 'active' class");
          this.classList.add('active');
        }
  
        console.log("[Accordion] Current class list:", this.classList);
  
        var panel = this.nextElementSibling;
        console.log("[Accordion] Panel element:", panel); 
  
        if (panel.style.maxHeight) {
          console.log("[Accordion] Panel is open, closing it. Current maxHeight:", panel.style.maxHeight);
          panel.style.maxHeight = null;
          console.log("[Accordion] Panel maxHeight set to null");
        } else {
          console.log("[Accordion] Panel is closed, opening it. Current scrollHeight:", panel.scrollHeight);
          panel.style.maxHeight = panel.scrollHeight + "px";
          console.log("[Accordion] Panel maxHeight set to:", panel.style.maxHeight);
        }
      });
    }
  
    // Log if no accordion elements were found
    if (acc.length === 0) {
      console.warn("[Accordion] WARNING: No accordion elements found with class 'accordion'");
    } 
  }); 